import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../context/ThemeContext';
import { useLanguage } from '../context/LanguageContext';
import Section from '../components/ui/Section';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

const TrustedBy = () => {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const { language } = useLanguage();
  const isDark = theme === 'dark';
  
  const baseClients = [
    {
      id: 1,
      nameKey: 'clients.client1',
      logo: 'https://cdn.prod.website-files.com/6857c979dd78e3f5bf316236/6873c7c32d18853d76df6519_Group%201171275252.svg'
    },
    {
      id: 2,
      nameKey: 'clients.client2',
      logo: 'https://cdn.prod.website-files.com/6857c979dd78e3f5bf316236/6873c80a74991b101ff89296_Group%201171275252%20(1).svg'
    },
    {
      id: 3,
      nameKey: 'clients.client3',
      logo: 'https://cdn.prod.website-files.com/6857c979dd78e3f5bf316236/6873c834f3b36e7f53f047f8_Group%201171275252%20(2).svg'
    },
    {
      id: 4,
      nameKey: 'clients.client4',
      logo: 'https://cdn.prod.website-files.com/6857c979dd78e3f5bf316236/6873c856a34854ab3764a6c2_Group%201171275252%20(3).svg'
    },
    {
      id: 5,
      nameKey: 'clients.client5',
      logo: 'https://cdn.prod.website-files.com/6857c979dd78e3f5bf316236/6873c8c78c0e440e2d1eb50a_Group%201171275252%20(4).svg'
    },
    {
      id: 6,
      nameKey: 'clients.client6',
      logo: 'https://cdn.prod.website-files.com/6857c979dd78e3f5bf316236/6873c8e492953bb8b0e9095c_Group%201171275238.svg'
    }
  ];

  // Duplicate clients 3 times for more items (18 total)
  const clients = [
    ...baseClients, 
    ...baseClients.map(c => ({ ...c, id: c.id + 6 })), 
    ...baseClients.map(c => ({ ...c, id: c.id + 12 }))
  ];

  return (
    <Section id="trusted-by">
      <motion.div
        initial={{ opacity: 0, y: 20, filter: 'blur(10px)' }}
        whileInView={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <p className={`text-center mb-8 text-sm uppercase tracking-wider font-semibold ${isDark ? 'text-white/60' : 'text-afsc-charcoal/60'}`}>
          {t('trustedBy.title')}
        </p>
        <div className="relative">
          <Swiper
            key={`trusted-by-swiper-${language}`}
            modules={[Autoplay]}
            spaceBetween={40}
            slidesPerView={2}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
              stopOnLastSlide: false,
            }}
            loop={true}
            speed={2000}
            freeMode={false}
            allowTouchMove={false}
            watchSlidesProgress={true}
            dir={language === 'ar' ? 'rtl' : 'ltr'}
            breakpoints={{
              640: {
                slidesPerView: 3,
                spaceBetween: 50,
              },
              768: {
                slidesPerView: 4,
                spaceBetween: 60,
              },
              1024: {
                slidesPerView: 5,
                spaceBetween: 70,
              },
              1280: {
                slidesPerView: 6,
                spaceBetween: 80,
              },
            }}
            className="trusted-by-swiper"
          >
            {clients.map((client, index) => (
              <SwiperSlide key={`${client.id}-${index}`}>
                <motion.div
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5 }}
                  className="flex items-center justify-center h-24 px-4"
                >
                  <img
                    src={client.logo}
                    alt={t(client.nameKey)}
                    className="max-h-16 w-auto object-contain transition-all duration-300 filter"
                    style={{
                      filter: isDark ? 'brightness(0) invert(1)' : 'brightness(0)'
                    }}
                    loading="lazy"
                  />
                </motion.div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </motion.div>
    </Section>
  );
};

export default TrustedBy;

